import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** `POST …/transcriptions` carries no body: the target is entirely in the URL. */
class LaunchWorkflowRunSourceTranscription {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly runId: number,
		public readonly sourceId: number,
	) {
		Object.freeze(this);
	}
}

export default LaunchWorkflowRunSourceTranscription;
